module.exports = __webpack_public_path__ + "img/loadingTestInput.18a8d852.png";